/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_11_P1Inputs */

const en_terms_section_11_p1 = /** @type {(inputs: Terms_Section_11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo may update these terms. When we do, the “last updated” date at the top of this page changes with them.`)
};

const lv_terms_section_11_p1 = /** @type {(inputs: Terms_Section_11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo var šos noteikumus atjaunināt. Tad mainās arī datums „pēdējoreiz atjaunināts” lapas augšā.`)
};

/**
* | output |
* | --- |
* | "Lindevo may update these terms. When we do, the “last updated” date at the top of this page changes with them." |
*
* @param {Terms_Section_11_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_11_p1 = /** @type {((inputs?: Terms_Section_11_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_11_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_11_p1(inputs)
	return en_terms_section_11_p1(inputs)
});